import { Component, OnInit, AbstractType, AfterViewInit, OnDestroy } from '@angular/core';
import { MessageService, ConfirmationService } from 'primeng/api';
import { GifcardVirtualService } from 'src/app/services/gifcardVirtual.service';
import { GiftCardOrderSalesModel, GiftCardTypesModel, GiftCardVirtualsModel, GiftCardVirtualsModelNCR, PlantillaNCR } from "src/app/models/gifcardVirtual.model";
import { saveAs } from 'file-saver';
import { ExcelService } from 'src/app/services/excel.service';
import { JobService } from 'src/app/services/job.service';
import { AuthService } from 'src/app/services/auth.service';
import { EmailService } from 'src/app/services/email.service';
import { EmailSendModel, EmailTemplateModel } from 'src/app/models/email.model';
import { timer } from 'rxjs';
import { Subscription } from 'rxjs';
import { TraceService } from 'src/app/services/trace.service';
import { TraceModel } from 'src/app/models/trace.model';
import { FileUploadValidators, FileUploadControl } from '@iplab/ngx-file-upload';
import * as XLSX from 'xlsx';

@Component({
    selector: 'ordersales-list.component',
    templateUrl: 'ordersales-list.component.html',
    styleUrls: ['ordersales-list.component.css']
})

export class OrderSalesListComponent implements OnInit, OnDestroy {
    constructor(private _giftCardService: GifcardVirtualService,
        private messageService: MessageService,
        private excelService: ExcelService,
        private jobService: JobService,
        private authService: AuthService,
        private confirmationService: ConfirmationService,
        private emailService: EmailService,
        private traceService: TraceService) { }

    private subscription: Subscription = new Subscription();
    totalOrderSales: number;
    dlgOrderSales: boolean;
    dlgEmailFails: boolean;
    dlgUpdateEmail: boolean;
    itemOrderSales;
    itemSendFails;
    selectOrderSales: GiftCardOrderSalesModel;
    datasourceTablaOrderSales: GiftCardOrderSalesModel[] = [];
    colsTablaOrderSales: any[];
    colsTablaEmailFails: any[];
    colsTablaTrace: any[];
    dataDetail: {};
    datasourceGiftCardVirtual: GiftCardVirtualsModel[] = [];
    datasourceEmailFails: EmailSendModel[] = [];
    datasourceTrace: TraceModel[] = [];
    loading: boolean = false;
    currentUser: string;

    id_emailsend: number;
    email_sender: string;
    email_recipient: string;
    email_subject: string;
    email_bodyhtml: string;
    email_path_file: string;
    email_name_client: string;
    email_contacto: string;
    email_endpoint: string;
    emailValidateLast: string;
    sendMasivo: string;
    datasourceEmailTemplate: EmailTemplateModel[];
    fileUploadControlNCR = new FileUploadControl(FileUploadValidators.filesLimit(1));
    displayDialogNCR = false; 

    ngOnInit() {
        this.currentUser = this.authService.getCurrentUser();
        this.createColumnsTablaGiftCardVirtual();
        this.createColumnsTablaEmailFails();
        this.createColumnsTableTrace();              
        this.refreshData();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    refreshData() {
        this.subscription.add(this.populateTableOrderSales());
        this.subscription.add(this.subscribeToData());
    }

    subscribeToData() {
        this.subscription.add(console.log("refreshdata"));
        this.subscription.add(
            timer(60000).subscribe(() => this.refreshData())
        );
    }

    createColumnsTablaGiftCardVirtual() {
        this.colsTablaOrderSales = [
            { field: 'DESC_MODELO_GIFT_CARD', header: 'Modelo Giftcard', width: '10%', align: 'center' },
            { field: 'NRORUC_CLIENTE', header: 'RUC', width: '7%', align: 'center' },
            { field: 'RAZSOC_CLIENTE', header: 'Razón Social', width: '25%', align: 'center' },
            { field: 'NRO_ORDEN_COMPRA', header: 'Nro. Ord. Compra', width: '8%', align: 'center' },
            { field: 'IMP_ORDEN_COMPRA', header: 'Importe', width: '8%', align: 'center' },
            { field: 'CAN_ORDEN_COMPRA', header: 'Cant.', width: '6%', align: 'center' },
            { field: 'FEC_INI_VIGENCIA', header: 'Fec. Activación', width: '6%', align: 'center' },
            { field: 'FEC_FIN_VIGENCIA', header: 'Fec. Baja', width: '6%', align: 'center' }
        ];
    }

    createColumnsTableTrace() {
        this.colsTablaTrace = [
            { field: 'ACTION', header: 'Acción', width: '10%', align: 'center' },
            { field: 'OBSERVATION', header: 'Observaciones', width: '60%', align: 'center' },
            { field: 'CREATIONUSER', header: 'Usuario', width: '10%', align: 'center' },
            { field: 'CREATIONDATE', header: 'Fecha Acción', width: '20%', align: 'center' }
        ];
    }

    createColumnsTablaEmailFails() {
        this.colsTablaEmailFails = [
            { field: 'ID_EMAILSEND', header: 'ID', width: '5%', align: 'center' },
            { field: 'NAME_FILE', header: 'Nombre Archivo', width: '15%', align: 'center' },
            { field: 'EMAIL_SEND', header: 'Correo', width: '15%', align: 'center' },
            { field: 'NAME_SEND', header: 'Enviado a', width: '15%', align: 'center' },
            { field: 'MESSAGE_SEND', header: 'Mensaje', width: '30%', align: 'center' },
            { field: 'STATUS_TEXT', header: 'Estado', width: '10%', align: 'center' }
        ];
    }

    populateTableOrderSales() {
        this.loading = true;
        this._giftCardService.GetGiftCardOrderSales().subscribe(
            (response: GiftCardOrderSalesModel[]) => {
                this.datasourceTablaOrderSales = response;
                this.totalOrderSales = this.datasourceTablaOrderSales.length;
                this.loading = false;
            },
            (error) => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al listar las ordenes de compra.' });
            }
        )
    }

    populateTablaGiftCardVirtual() {
        this.loading = true;
        let order = {
            "p_id_order_gift_card": this.itemOrderSales.ID_ORDER_SALES,
            "p_id_modelo_gift_card": this.itemOrderSales.ID_MODELO_GIFT_CARD,
            "p_id_cliente_gift_card": this.itemOrderSales.ID_CLIENTE,
            "p_id_contact_gift_card": this.itemOrderSales.ID_CONTACT
        };
        this._giftCardService.GetGiftCardVirtualsNewCode(order).subscribe(
            (response: GiftCardVirtualsModel[]) => {
                this.datasourceGiftCardVirtual = response;
                this.excelService.exportAsExcelFile(this.datasourceGiftCardVirtual, 'giftcard');
                this.loading = false;
            },
            (error) => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al listar gift card.' });
            }
        )
    }

    populateOrderSalesTrace(order) {
        let params = {
            "p_id_order_gift_card": order.ID_ORDER_SALES,
            "p_type_order_sales": this._giftCardService.TYPE_ORDER_SALES_VIRTUAL
        };
        this.traceService.GetOrderSalesTraceByOrder(params).subscribe(
            (response: TraceModel[]) => {
                this.datasourceTrace = response;
            },
            (error) => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al listar trace de la orden de compra.' });
            }
        )
    }

    populateTableEmailFails(order: GiftCardOrderSalesModel) {
        let params = {
            "p_id_order_gift_card": order.ID_ORDER_SALES
        }
        this.emailService.GetGiftCardsEmailSendError(params).subscribe(
            (response: EmailSendModel[]) => {
                this.datasourceEmailFails = response;
                this.sendMasivo = this.datasourceEmailFails[0].TYPE_SEND;
            },
            (error) => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al listar email con errores.' });
            }
        );
    }

    onShowConfirmAnulate(order: GiftCardOrderSalesModel) {
        this.confirmationService.confirm({
            message: '¿Está seguro de anular la orden de compra?',
            accept: () => {
                this.anulateOrderSalesStatus(order);
            }
        });
    }

    anulateOrderSalesStatus(order: GiftCardOrderSalesModel) {
        this.loading = true;
        let params = {
            "p_id_order_gift_card": order.ID_ORDER_SALES,
            "p_id_modelo_gift_card": order.ID_MODELO_GIFT_CARD,
            "p_id_cliente_gift_card": order.ID_CLIENTE,
            "p_id_contact_gift_card": order.ID_CONTACT,
            "p_flg_activo": 0
        }
        this._giftCardService.UpdateOrderSalesStatus(params).subscribe(
            (response) => {
                this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Anulación paso 1: exitoso.' });
                this.anulateGiftCardNCR(order);
            },
            (error) => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al anular orden de compra.' });
            }
        )
    }

    anulateGiftCardNCR(order: GiftCardOrderSalesModel) {
        let params = {
            "p_branchId": 999,
            "p_assignationBatch": order.ID_ASSIGN_NCR,
            "p_distributionBatch": order.ID_DISTR_NCR,
            "p_status": "CA"
        };
        this._giftCardService.UpdateGiftCardStatusNCR(params).subscribe(
            (response) => {
                this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Anulación paso 2: exitoso.' });
                this.anulateActivation(order);
            },
            (error) => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al activar las gift card en el NCR.' });
            }
        )
    }

    anulateActivation(order: GiftCardOrderSalesModel) {
        let params = {
            "p_id_job": order.ID_JOB,
            "p_creationuser": this.currentUser,
            "p_type_operation": 3,
            "p_flg_activo": 0
        }
        this.jobService.UpdateGiftCardJobActivation(params).subscribe(
            (response) => {
                this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Anulación realizada con éxito.' });
                this.populateTableOrderSales();
                this.loading = false;
            },
            (error) => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al actualizar Job.' });
            }
        )
    }

    onShowDlgOrderSales(order: GiftCardOrderSalesModel) {
        this.itemOrderSales = order;
        this.dlgOrderSales = true;
        this.populateOrderSalesTrace(order);
    }

    onShowDlgEmailFails(order: GiftCardOrderSalesModel) {
        this.itemOrderSales = order;
        this.dlgEmailFails = true;
        this.populateTableEmailFails(order);
    }

    onShowUpdateEmail(sendFail: EmailSendModel) {
        this.itemSendFails = sendFail;
        this.emailValidateLast = this.itemSendFails.EMAIL_SEND;
        this.dlgUpdateEmail = true;
    }

    exportAsXLSX(order: GiftCardOrderSalesModel): void {
        this.itemOrderSales = order;
        this.populateTablaGiftCardVirtual();
    }

    updateCorreo() {
        this.loading = true;
        if (this.itemSendFails.EMAIL_SEND && this.validateEmail(this.itemSendFails.EMAIL_SEND)) {
            if (!(this.itemSendFails.EMAIL_SEND == this.emailValidateLast)) {
                if (this.sendMasivo == 'M') {
                    this.updateCorreoContacto();
                    this.emailValidateLast = "";
                }
                else {
                    this.updateCorreoGiftCard();
                    this.emailValidateLast = "";
                }
            }
            else {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Debe ingresar un email diferente al anterior ingresado' });
            }
        }
        else {
            this.loading = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Debe ingresar un email válido' });
        }


    }

    validateEmail(email: string) {
        let patron = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        return patron.test(email);
    }


    updateCorreoContacto() {
        let contact = {
            "p_id_contact": this.itemSendFails.ID_CONTACT,
            "p_id_cliente": this.itemSendFails.ID_CLIENTE,
            "p_nombre_contacto": this.itemSendFails.NAME_SEND,
            "p_correo_contacto": this.itemSendFails.EMAIL_SEND,
            "p_flag_activo": 1
        };
        this._giftCardService.UpdateContact(contact).subscribe(
            (response) => {
                this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'El correo se actualizó correctamente.' });
                this.dlgUpdateEmail = false;
                this.loading = false;
            },
            (error) => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al actualizar correo' });
            }
        )
    }

    updateCorreoGiftCard() {
        let giftCard = {
            "p_id_gift_card": this.itemSendFails.ID_GIFT_CARD,
            "p_id_order_gift_card": this.itemOrderSales.ID_ORDER_SALES,
            "p_id_modelo_gift_card": this.itemOrderSales.ID_MODELO_GIFT_CARD,
            "p_id_cliente_gift_card": this.itemOrderSales.ID_CLIENTE,
            "p_id_contact_gift_card": this.itemOrderSales.ID_CONTACT,
            "p_nomb_gift_card": this.itemSendFails.NAME_SEND,
            "p_docu_gift_card": this.itemSendFails.DOCUM_GIFT_CARD,
            "p_text_gift_card": this.itemSendFails.TEXTO_GIFT_CARD,
            "p_mail_gift_card": this.itemSendFails.EMAIL_SEND
        };
        this._giftCardService.UpdateGiftCardDataPrint(giftCard).subscribe(
            (response) => {
                this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'El correo se actualizó correctamente.' });
                this.dlgUpdateEmail = false;
                this.loading = false;

            },
            (error) => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al actualizar correo' });
            }
        )
    }

    reSendEmail() {
        this.loading = true;
        let params = {
            "p_email_type": this.sendMasivo == 'M' ? 2 : 1
        }
        this.emailService.GetGiftCardsEmailByType(params).subscribe(
            (response: EmailTemplateModel[]) => {
                this.datasourceEmailTemplate = response;
                this.email_sender = this.datasourceEmailTemplate[0].EMAILSENDER;
                this.email_subject = this.datasourceEmailTemplate[0].EMAILSUBJECT;
                this.email_bodyhtml = this.datasourceEmailTemplate[0].EMAILBODYHTML;
                this.email_endpoint = this.datasourceEmailTemplate[0].ENDPOINT;
                this.buildEmailSend().then(success => {
                    if (success) {
                        this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Proceso de reenvío de correo exitoso.' });
                        this.dlgEmailFails = false;
                        this.loading = false;
                    }
                });
            },
            (error) => {
                console.log("reSendEmail", error);
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al cargar template email.' });
            }
        );
    }

    buildEmailSend() {
        return new Promise(resolve => {
            this.datasourceEmailFails.forEach(send => {
                this.id_emailsend = send.ID_EMAILSEND;
                this.email_recipient = send.EMAIL_SEND;
                //this.email_path_file = send.PATH_FILE;
                this.email_path_file = `${this.email_endpoint}/giftCardVirtual/downloadByHash?hash=${send.HASH}`
                this.email_name_client = send.NAME_SEND;
                this.sendEmail();
                resolve(true);
            });
        });
    }

    sendEmail() {
        //let formatName = this.email_bodyhtml.replace("${nombre_cliente}", this.email_name_client);
        //let bodyhtmlformat = formatName.replace("${path_file}", this.email_path_file);
        let params = {
            "p_id_emailsend": this.id_emailsend,
            "p_email_sender": this.email_sender,
            "p_email_subject": this.email_subject,
            //"p_email_bodyhtml" : bodyhtmlformat,
            "p_email_name_client": this.email_name_client,
            "p_email_type_send": this.sendMasivo,
            "p_email_recipient": this.sendMasivo == 'M' ? this.itemOrderSales.CORREO_CONTACTO : this.email_recipient,
            "p_email_path_file": this.email_path_file
        }
        this.emailService.SendEmailGiftCard(params).subscribe(
            (response) => { },
            (error) => {
                console.log(error);
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al enviar correos.' });
            }
        );
    }

    onShowDialog() {
        this.displayDialogNCR = true;
    }

    onUploadNCR() {
        if (this.fileUploadControlNCR.valid && this.fileUploadControlNCR.value.length) {
          let workBook = null;
          let jsonData = null;
          const reader = new FileReader();
          const file = this.fileUploadControlNCR.value[0];
          reader.onload = (event) => {
            const data = reader.result;
            workBook = XLSX.read(data, { type: 'binary' });
            jsonData = workBook.SheetNames.reduce((initial, name) => {
              const sheet = workBook.Sheets[name];
              initial[name] = XLSX.utils.sheet_to_json(sheet);
              return initial;
            }, {});
            this.generarDatosGiftcardNCR(jsonData);
            console.log(jsonData);
          }
          reader.readAsBinaryString(file);
          this.fileUploadControlNCR.clear();
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Debe seleccionar solo 01 archivo excel de información adicional.' });
        }
      }

    descargarPlantillaNCR() {
        let plantillaNCR: PlantillaNCR[] = [{"GIFTCARD": 0, "SECUENCIAL": 0}];
        this.excelService.exportAsExcelFile(plantillaNCR, 'PLANTILLA_NCR');
    }
    
    generarDatosGiftcardNCR(jsonData) {
    this.loading = true;
    JSON.stringify("Iniciando GenerarDatosGiftcardNCR : " + jsonData);

    let request = [];
    for (let i = 0; i < jsonData.data.length; i++) {   
        let solicitud = {
        "giftcard" : jsonData.data[i].GIFTCARD,
        "secuencial": jsonData.data[i].SECUENCIAL
        };

        request.push(solicitud);
    }   
        
    this._giftCardService.GenerateDataGiftcardsNCR(request).subscribe((response: GiftCardVirtualsModelNCR[]) => {
        console.log("response", response);
        this.loading = false;
        this.displayDialogNCR = false;
        this.excelService.exportAsExcelFile(response, 'giftcardNcr');
    }, (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrió un error al actualizar los datos.' });
    })        
    }

    downloadIMGModel() {
        saveAs(this.itemOrderSales.IMG_MODELO_GIFT_CARD, "modelo.jpg");
    }

    downloadIMGOrder() {
        saveAs(this.itemOrderSales.IMG_ORDEN_COMPRA, "orden.jpg");
    }

    downloadIMGCotizacion() {
        saveAs(this.itemOrderSales.IMG_COTIZACION, "cotizacion.jpg");
    }

    donwloadAdicional1() {
        saveAs(this.itemOrderSales.IMG_ADICIONAL1, "adicional.jpg");
    }

    donwloadAdicional2() {
        saveAs(this.itemOrderSales.IMG_ADICIONAL2, "adiciona2.jpg");
    }

    donwloadAdicional3() {
        saveAs(this.itemOrderSales.IMG_ADICIONAL3, "adiciona3.jpg");
    }

    donwloadLiquidacion() {
        saveAs(this.itemOrderSales.IMG_LIQUIDACION, "liquidacion.jpg");
    }

    donwloadConstancia() {
        saveAs(this.itemOrderSales.IMG_CONSTANCIA, "constanciajpg");
    }

    donwloadGuia() {
        saveAs(this.itemOrderSales.IMG_GUIA, "guia.jpg");
    }
}